export default __webpack_public_path__ + "static/media/app.8714f365.jpeg";